import { StrictMode } from "react"
import { createRoot } from "react-dom/client"
import ErrorPage from "./routes/error.tsx"
import { RouterProvider, createBrowserRouter } from "react-router-dom"
import OutletPage from "./Outlet.tsx"

import "./index.css"
import App from "./App.tsx"

const router = createBrowserRouter([
	{
		path: "/",
		element: <OutletPage />,
		errorElement: <ErrorPage />,
		children: [
			{
				path: "/",
				element: <App />,
			},
		],
	},
])

createRoot(document.getElementById("root")!).render(
	<StrictMode>
		<RouterProvider router={router} />
	</StrictMode>
)
